var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "pagination" },
    [
      _vm.currentPage > 1
        ? _c("li", [
            _c(
              "a",
              {
                style: `${
                  _vm.disabled ? "user-select: none; opacity: .5" : ""
                }`,
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.changePage(_vm.currentPage - 1)
                  },
                },
              },
              [_vm._v("Anterior")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.buttons, function (button) {
        return _c("li", { key: button.key }, [
          button.text !== "..."
            ? _c(
                "a",
                {
                  style: `${
                    _vm.disabled ? "user-select: none; opacity: .5" : ""
                  }`,
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.changePage(button.text)
                    },
                  },
                },
                [_vm._v("\n      " + _vm._s(button.text) + "\n    ")]
              )
            : _c(
                "span",
                {
                  style: `user-select: none; ${
                    _vm.disabled ? " opacity: .5" : ""
                  }`,
                },
                [_vm._v("...")]
              ),
        ])
      }),
      _vm._v(" "),
      _vm.currentPage < _vm.totalPages
        ? _c("li", [
            _c(
              "a",
              {
                style: `${
                  _vm.disabled ? "user-select: none; opacity: .5" : ""
                }`,
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.changePage(_vm.currentPage + 1)
                  },
                },
              },
              [_vm._v("Siguiente")]
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }